import { INTEGRATION_PROVIDERS } from '@vy/types';
import { useXeroCustomers } from '../../../../../hooks/requests/integrations';
import { useExternalCustomerSelection } from '../../hooks/use-external-customer-selection';

export const useXeroCustomerSelection = () => {
  const { customers, ...rest } = useExternalCustomerSelection({
    provider: INTEGRATION_PROVIDERS.xero,
    useCustomersHook: useXeroCustomers,
  });

  return {
    xeroCustomers: customers,
    ...rest,
  };
};
